<script lang="ts">
  import { Button } from "sveltestrap";
  import { logEvent } from "../helpers/analytics";

  export let githubUrl: string;
</script>

<a
  target="_blank"
  rel="noopener noreferrer"
  href={githubUrl}
  on:click={() => logEvent("view_item")}
>
  <Button class="github-button">
    <div class="btn-flex">
      <i class="icon" />
      <span>Install the app</span>
    </div>
  </Button>
</a>

<style>
  :global(.github-button) {
    color: #fff;
    background: #28a745 !important;
    /* background-image: linear-gradient(-180deg, #34d058, #28a745 90%); */
    border: 1px solid rgba(27, 31, 35, 0.2);
    margin-left: 5px;
    width: 191px;
    height: 58px;
  }

  :global(.github-button:hover) {
    color: #fafafa;
    background-color: #3A9949;
    /* background-image: linear-gradient(-180deg, #2fcb53, #269f42 90%); */
    background-position: -0.5em;
    border-color: rgba(27, 31, 35, 0.5);
  }
  .btn-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    background-image: url("../images/mark-github.svg");
    background-size: cover;
    display: inline-block;
    height: 15px;
    width: 15px;
    margin-right: 10px;
    fill: white;
    stroke: white;
  }

  span {
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
  }
</style>
